<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field :rules="[rules.required]" v-model="crud.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="crud.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea rows="3" v-model="crud.description" label="Description"></v-textarea>
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-for="(question, index) in crud.question_group.questions"
        :key="'Question' + index"
      >
        <app-pronunciation-card
          v-model="question.question_file"
          :content.sync="question.content"
          @delete="removeQuestion(index)"
        />
      </v-col>
      <v-col cols="12">
        <app-add @new-exercise="onNewWord">Add New Word</app-add>
      </v-col>
      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto"
        >Save</v-btn
      >
    </v-row>
  </v-form>
</template>
<script>
import rulesMixin from "@/mixins/rulesMixin";
import restoreMixin from "@/mixins/restoreMixin";
import audioMixin from "@/mixins/audioMixin";
import pronunciationMixin from "@/mixins/pronunciationMixin";
import { getPronunciation, postPronunciation, postQuestions } from "@/api/api";
import Add from "@/components/Admin/crud/Grammar/Add.vue";
import PronunciationCard from "./Pronunciation/PronunciationCard.vue";

export default {
  components: {
    appPronunciationCard: PronunciationCard,
    appAdd: Add,
  },
  mixins: [rulesMixin, restoreMixin, audioMixin, pronunciationMixin],
  data() {
    return {
      loading: false,
      crud: {
        title: "",
        subtitle: "",
        description: "",
        question_group: {
          name: "Pronunciation",
          questions: [],
        },
      },
    };
  },
  computed: {
    practice() {
      return this.$store.getters["admin/practice"];
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let crud = { ...this.crud };
      try {
        crud.practice = this.practice.uuid;
        const response = await postPronunciation(crud);
        this.crud.uuid = response.data.uuid;

        if (response.data.question_group.uuid) {
          this.crud.question_group.uuid = response.data.question_group.uuid;
        } else this.crud.question_group.uuid = response.data.question_group;
        let newQuestions = JSON.parse(JSON.stringify(this.crud.question_group));
        newQuestions.questions = newQuestions.questions.map((element, index) => {
          element.content = JSON.stringify(element.content);
          element.question_file = this.crud.question_group.questions[index].question_file;
          return element;
        });
        const questions = await postQuestions(newQuestions);
        this.crud.question_group.uuid = questions.uuid;
        this.crud.question_group.questions.forEach((element, index) => {
          element.uuid = questions.questions[index].uuid;
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loading = false;
    },
    async create() {
      const uuid = this.practice.pronunciation_step;
      if (uuid) {
        const response = await getPronunciation(uuid);
        this.crud = response.data;

        this.crud.question_group.questions = this.crud.question_group.questions.map((element) => {
          element.content = JSON.parse(element.content);
          return element;
        });
      }
    },
  },
  async created() {
    this.create();
  },
};
</script>
